import { useEffect } from "react"

export function useClickOutside({ dropdownRef, triggerRef, onClickOutside }) {
	useEffect(() => {
		function handleClickAway(e) {
			const dropdown = dropdownRef?.current
			const trigger = triggerRef?.current

			if(!dropdown || !trigger) {
				return
			}

			if (!dropdown.contains(e.target) && !trigger.contains(e.target)) {
				onClickOutside()
			}
		}

		document.addEventListener('click', handleClickAway)

		return () => {
			document.removeEventListener('click', handleClickAway)
		}
	}, [])
}
